import React from 'react'
import { Cuestionary } from './Cuestionary'
import { useLocation } from 'react-router-dom'

const ViewCuestionary = () => {
  const location = useLocation()

  return (
    <>
      <Cuestionary
        IdQuestionnaireAnswer={location.state.IdQuestionnaireAnswer}
      />
    </>
  )
}

export default ViewCuestionary
